  const keyApiOrderReceive = "https:\/\/endrock.novapower.io\/endrockapi\/v3\/app\/estimatedArrival2025\/brushonblock\/all";
  document.addEventListener("DOMContentLoaded", () => {
    const dateElement = document.getElementById("orderby-receiveby-value");
    if (!dateElement) return;

    if (!keyApiOrderReceive || typeof keyApiOrderReceive !== "string") {
      dateElement.textContent = "—";
      dateElement.classList.remove("loading-skeleton");
      return;
    }

    dateElement.innerHTML = "&nbsp;";

    fetch(keyApiOrderReceive)
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then((data) => {
        if (data?.data?.delivery_max_date_end_at_desc) {
          const dateObject = new Date(data.data.delivery_max_date_end_at_desc);
          const options = { weekday: "short", month: "short", day: "2-digit" };
          const locale = document.documentElement.lang || "en-US";
          const formattedDate = new Intl.DateTimeFormat(locale, options).format(dateObject);
          dateElement.textContent = ` ${formattedDate}`;
        } else {
          dateElement.textContent = "—";
        }
      })
      .catch(() => {
        const container = document.querySelector(".orderby-receiveby");
        if (container) container.classList.add("orderby-receiveby--error");
        dateElement.textContent = "—";
      })
      .finally(() => {
        dateElement.classList.remove("loading-skeleton");
      });
  });